import moment from "moment";

export const fetchDateFormat = (dateTime: any) => {
    return moment(dateTime).format("DD-MMM-YYYY");
  };